import React from 'react';
import PropTypes from 'prop-types';
import { CUSTOM_ATTRIBUTE_TYPES as types } from 'Screens/Contextualization/Manage/components/CustomAttributesModal/constants';
import TYPE_TO_CONTENT from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/CustomFieldsTab/contents';

const CustomFieldContent = ({
  field, onCancel, vuln, initialValue, onSaveCallback, onSaveCustomAttribute, entity
}) => {
  const onSave = (vuln, fieldName, fieldValue) => {
    if (entity === 'vuln') {
      onSaveCustomAttribute(vuln, fieldName, fieldValue);
    } else {
      onSaveCustomAttribute(fieldName, fieldValue);
    }

    if (onSaveCallback) onSaveCallback();
  };
  const Content = TYPE_TO_CONTENT[field.field_type];
  return (
    <Content vuln={ vuln } field={ field } onCancel={ onCancel } onSave={ onSave } initialValue={ initialValue } />
  );
};

CustomFieldContent.propTypes = {
  field: PropTypes.shape({
    field_type: PropTypes.oneOf([types.STRING, types.INTEGER,
      types.FLOAT, types.LIST, types.MARKDOWN, types.CHOICE, types.DATE]).isRequired
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSaveCallback: PropTypes.func.isRequired,
  vuln: PropTypes.shape({
    _id: PropTypes.number.isRequired
  }).isRequired,
  initialValue: PropTypes.oneOfType([
    PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.string)
  ]),
  onSaveCustomAttribute: PropTypes.func,
  entity: PropTypes.string
};

CustomFieldContent.defaultProps = {
  initialValue: '',
  onSaveCustomAttribute: null,
  entity: ''
};
export default CustomFieldContent;
